import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { URL_LANGUAGES } from './i18n.js';
import { Root } from './app.js';
import { BookRoot } from './book.js';
import { initAnalytics } from './analytics.js';

const params = new URLSearchParams(window.location.search);

const distributorParam = params.get('distributor');
window.distributor = distributorParam && distributorParam.trim() ? distributorParam.trim() : false;

const languageParam = params.get('language');
window.overrideLanguage =
  languageParam && /^[a-z]{2}$/i.test(languageParam.trim()) ? languageParam.trim().toLowerCase() : false;

const countryParam = params.get('country');
window.country = countryParam && /^[a-z]{2}$/i.test(countryParam.trim()) ? countryParam.trim().toUpperCase() : false;

// Le premier segment du chemin (/fr/, /en/, /it/, ...) est la source de vérité pour la langue,
// posée par le serveur au premier rendu : on doit recalculer exactement la même valeur ici pour
// que l'hydratation ne détecte pas de différence entre le HTML serveur et le rendu client.
function getLangFromPath() {
  const segment = window.location.pathname.split('/').filter(Boolean)[0];
  return URL_LANGUAGES.includes(segment) ? segment : 'en';
}

// La page détail d'un livre (/book/slug, sans code langue — voir server/index.mjs) est hydratée
// avec son propre arbre React, distinct de la page d'accueil (/xx/).
// Plusieurs URL mènent à une page livre (/book/slug, /P0225FR, /izvor/slug) : le serveur indique
// le type de page dans window.__SSR_DATA__ plutôt que de le redéduire de l'URL.
function isBookPage() {
  return Boolean(window.__SSR_DATA__ && window.__SSR_DATA__.page === 'book');
}

if (isBookPage()) {
  // Pas de code langue dans l'URL ici : `lang` vient de `window.__SSR_DATA__`, posé par le serveur
  // (`detectLanguage`, server/index.mjs) — on réutilise cette même valeur côté client plutôt que de
  // la redéduire, pour que l'hydratation retombe exactement sur le rendu serveur.
  const { lang: bookLang, book } = window.__SSR_DATA__ || {};
  hydrateRoot(document.getElementById('root'), <BookRoot lang={bookLang || 'en'} book={book} />);
} else {
  const initialData = window.__SSR_DATA__ || {};
  // /izvor/ n'a pas de code langue : le serveur transmet la langue utilisée pour le rendu.
  const lang = initialData.lang || getLangFromPath();
  hydrateRoot(document.getElementById('root'), <Root lang={lang} initialData={initialData} />);
}

initAnalytics();
